import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";

var root = $.from_html(`<div class="slex-swatch"></div>`);

export default function Swatch($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var div = root();

	$.template_effect(($0) => $.set_attribute(div, 'data-tone', $0), [() => text($.get(p).tone ?? $.get(p).color, "primary")]);
	$.append($$anchor, div);
	$.pop();
}